<template>
    <div class="tripLeft">
        <div class="top">
            <div class="firstLine">
                <div :style="(costPrice > 0 || planCollectionPriceDaiFu1 > 0)?'':'text-align:center'"
                     style="    width: 20%;">
                    <span style="font-weight: bold;font-size: 0.2rem;">{{
                            $store.state.planId ? $store.state.planId : '请先选择一个方案或者创建方案'
                        }}</span>
                    <span class="planNumber">方案编号</span>
                </div>
                <div v-if="costPrice > 0 || planCollectionPriceDaiFu1 > 0"
                     style="display: flex;justify-content: space-between;width: 78%;">
                    <div class="priceDiv" @click.stop="goMyCollection(1)">
                        <div style="font-size: 0.12rem;">收</div>
                        <div>
                            <span style="margin:0 0.1rem;">实收</span>
                            <span style="font-weight: bold;">{{ Number(planCollectionPriceDaiFu1) }}</span>
                        </div>
                    </div>
                    <div class="priceDiv" @click.stop="goMyCollection(1)">
                        <div style="font-size: 0.12rem;">支</div>
                        <div>
                            <span style="margin:0 0.1rem;">实付</span>
                            <span style="font-weight: bold;">{{ Number(payCostPrice.toFixed(2)) }}</span>
                        </div>
                    </div>
                    <div v-if="costPrice > 0 || planCollectionPriceDaiFu1 > 0" class="priceDiv"
                         style="margin-right: 0.3rem;">
                        <div>¥</div>
                        <div style="color: #DB4E1A;">
                            <span style="margin:0 0.1rem;">结余</span>
                            <span
                                style="font-weight: bold;">{{
                                    Number((planCollectionPriceDaiFu1 + commissionPrice - payCostPrice).toFixed(2))
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="secondLine">
                <div class="left">
                    <div class="budgetDiv">
                        <div class="tubiao">
                            <svg-icon :iconClass="'send'" style="width:10px;height:10px"></svg-icon>
                        </div>
                        <span>报价{{ budgetList.findIndex(ee => ee.id == chenckBudget.id) + 1 }}</span>
                        <span v-if="budgetList.length > 1" @click="changeBudget">切换报价单</span>
                    </div>
                    <div style="    display: flex;justify-content: space-between;">
                        <div class="budgetInfoDiv">
                            <div class="leftInfo">
                                <p>
                                    <span
                                        :style="(costPrice > 0 || planCollectionPriceDaiFu1 > 0)?'color: #40b8ff;':''">{{
                                            chenckBudget.useNumber
                                        }}人</span>
                                    <span>|</span>
                                    <span>{{
                                            (costPrice > 0 || planCollectionPriceDaiFu1 > 0) ? '有订单' : '无订单'
                                        }}</span>
                                </p>
                                <p>
                                    <el-tooltip :content="chenckBudget.planName" class="item" effect="dark"
                                                placement="top">
                                        <div>
                                            <span v-show="!updatePlanNameShow" class="planInfo"
                                                  @click="updatePlanNameShow = true">{{ chenckBudget.planName }}</span>
                                            <el-input v-show="updatePlanNameShow" v-model="chenckBudget.newPlanName"
                                                      size="mini"
                                                      style="width: 2rem;" @blur="updateBudgetMainName(2)"/>
                                        </div>
                                    </el-tooltip>
                                </p>
                                <p>
                                    <span v-if="customerName" style="    color: rgb(64, 184, 255);">{{
                                            customerName
                                        }}</span>
                                    <span v-else style="    color: rgb(64, 184, 255);"
                                          @click="linkInquiry">暂无客户信息</span>
                                </p>
                            </div>
                            <div style="border-left:1px solid #F2F2F2;margin: 0px 0.1rem;"></div>
                            <div class="rightInfo">
                                <div v-if="$refs.planDetail">
                                    <p @click="showCostPrice = true">
                                        <span class="blueButton">成本</span>&nbsp;&nbsp;
                                        <span :style="showCostPrice ? 'color: #DB4E1A;' : ''">{{
                                                Number($refs.planDetail.immediateCost)
                                            }}</span>
                                    </p>
                                    <p @click="showCostPrice = false">
                                        <span class="blueButton">报价</span>&nbsp;&nbsp;
                                        <span :style="showCostPrice ? '' : 'color: #DB4E1A;'">{{
                                                Number($refs.planDetail.immediateOffer)
                                            }}</span>
                                    </p>
                                    <p>
                                        <span class="blueButton">利润</span>&nbsp;&nbsp;
                                        {{
                                            Number(($refs.planDetail.immediateOffer - $refs.planDetail.immediateCost).toFixed(2))
                                        }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <p>
                                <button class="blueButton" @click="booking(0)">批量预定</button>
                            </p>
                            <p>
                                <button class="blueButton" @click="collection()">操作确认</button>
                            </p>
                            <p>
                                <button class="blueButton" @click="budgetDetail">预算明细</button>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="right" style="    display: flex;">
                    <div class="colletionDiv">
                        <p style=" color: #87888A;font-size: 0.15rem;">收款订单</p>
                        <div>
                            <p style="    margin-top: 0.1rem;" @click.stop="goMyCollection(2)">
                                <span class="spanlabel">应收</span>&nbsp;&nbsp;{{ Number(totalPlanCollectionPrice) }}
                            </p>
                            <p style="    margin-top: 0.1rem;" @click.stop="goMyCollection(1)">
                                <span class="spanlabel">已收</span>&nbsp;&nbsp;{{ Number(planCollectionPrice) }}</p>
                            <p style="    margin-top: 0.1rem;" @click.stop="goMyCollection(0)">
                                <span class="spanlabel">待收</span>&nbsp;&nbsp;{{
                                    Number((totalPlanCollectionPrice - planCollectionPrice).toFixed(2))
                                }}</p>
                        </div>
                    </div>
                    <div class="orderDiv" @click.stop="goMyOrder">
                        <p style=" color: #87888A;font-size: 0.15rem;">支出订单</p>
                        <div>
                            <p style="    margin-top: 0.1rem;">
                                <span class="spanlabel">总额</span>&nbsp;&nbsp;{{ Number(costPrice.toFixed(2)) }}</p>
                            <p style="    margin-top: 0.1rem;">
                                <span class="spanlabel">已付</span>&nbsp;&nbsp;{{ Number(payCostPrice.toFixed(2)) }}</p>
                            <p style="    margin-top: 0.1rem;" @click.stop="goMyOrder(1)">
                                <span class="spanlabel">待付</span>&nbsp;&nbsp;{{
                                    Number((costPrice - payCostPrice).toFixed(2))
                                }}</p>
                        </div>
                    </div>
                    <div class="buttonDiv" style="padding-top: 0.18rem;">
                        <p>
                            <button class="blueButton" style="padding: 0.03rem 0.2rem;">合同</button>
                            <button class="blueButton" style="padding: 0.03rem 0.2rem;" @click="invoicePage()">发票
                            </button>
                        </p>
                        <p>
                            <button class="blueButton" style="padding: 0.03rem 0.2rem;">名单</button>
                            <button class="blueButton" style="padding: 0.03rem 0.2rem;">导出</button>
                        </p>
                        <p></p>
                    </div>
                </div>
            </div>
        </div>
        <trip-detail ref="planDetail" :budgetList="budgetList" :chenckBudget="chenckBudget"
                     :hasCustomerName="hasCustomerName"
                     :hasOrderNumber="costPrice > 0" :showCostPrice="showCostPrice"></trip-detail>
        <budget-detail-dialog ref="budgetDetail" :chenckBudget="chenckBudget"
                              :planDetail="planDetail"></budget-detail-dialog>
        <el-dialog :append-to-body="true" :visible.sync="orderDetailVisible" class="orderDetailDialog" width="90%">
            <my-colletion-order ref="myCollectionOrder" :planId="$store.state.planId" :showSearch="false"
                                style="margin-top:0.2rem"></my-colletion-order>
        </el-dialog>
        <!--    <collection ref="collection"></collection>-->
        <!--操作确认新版-->
        <CollectionNew ref="collectionNew"></CollectionNew>
        <el-dialog :visible.sync="orderDetailVisible1" append-to-body class="orderDetailDialog" width="80%">
            <p style="font-size: 0.25rem;color: red;font-weight: bold">共 {{ total }} 个订单
                勾选订单金额：{{ checkTheAmount }}
                总计：{{ Number(costPrice.toFixed(2)) }}</p>
            <static-table :dataType="dataType" :loading="loading" :tableData="tableData"
                          @orderSelect="getSelectOrderList" @updateList="getOrderList()"></static-table>
            <Pagination :pageSize="requestParameters.size" :pageSizes="[20,40,80,100]" :perPage="requestParameters.page"
                        :totalNumber="total"
                        @loadTable="loadTable"></Pagination>
        </el-dialog>
        <el-dialog :visible.sync="linkInquiryVisible" title="关联询单" width="30%">
            <el-autocomplete v-model="linkInquiryId" :fetch-suggestions="querySearch"
                             placeholder="请输入你要关联的询单编号"
                             style="width: 300px;" @select="handleSelect">
                <template slot-scope="{ item }">
                    <div class="name">询单号:{{
                            item.id
                        }}/{{ item.informationResult.travelDate }}/{{ item.informationResult.destination }}
                    </div>
                </template>
            </el-autocomplete>
            <span slot="footer" class="dialog-footer">
        <el-button @click="linkInquiryVisible = false">取 消</el-button>
        <el-button type="primary" @click="linkInquirySure">确 定</el-button>
      </span>
        </el-dialog>
        <invoice-page ref="invoicePage"></invoice-page>
        <el-dialog :visible.sync="updateBudgetDialog" append-to-body class="orderDetailDialog" width="50%">
            <update-budget :budgetList="budgetList" :chenckBudget="chenckBudget"></update-budget>
        </el-dialog>
    </div>
</template>

<script>
import CollectionNew from "@/views/plan/leftMoudle/dialog/collectionNew.vue";
import {getBudgetInfo, getPlanInfo} from '../js/function'
import {days, sortByCreateTime} from '@/assets/utils/unit'
import {mapState} from "vuex"
import PlanApi from '@/components/Api/PlanApi.js'
import {Loading} from "@/components/Loding/Loading";
import TripDetail from './tripDetail.vue'
import budgetDetailDialog from "./dialog/budgetDetailDialog.vue"
import PayApi from "@/components/Api/pay";
import MyColletionOrder from '../../mechanism/components/myDealChild/child/myColletionOrder.vue'
import collection from "@/views/plan/leftMoudle/dialog/collection.vue"
import Api from '@/components/Api/index.js'
import staticTable from '../../mechanism/components/myDealChild/child/staticTable.vue'
import OrderApi from '@/components/Api/order.js'
import UpdateBudget from './dialog/updateBudget.vue'
import InvoicePage from './dialog/invoicePage.vue';
import Pagination from "@/views/common/Pagination.vue";

export default {
    computed: {
        ...mapState(['planId', 'budgetMainId']),
        checkTheAmount() {
            let price = 0
            this.selectOrderList.forEach(n => {
                price += Number(this.totalPrice(n.orderListDetailResultList))
            })
            return price.toFixed(2)
        }
    },
    data() {
        return {
            days,
            updateBudgetDialog: false,
            budgetList: [],
            chenckBudgetIndex: 0,
            chenckOrderBudgetIndex: 0,
            orderBudgetList: [],
            updateBudgetMainNameShow: false,
            updatePlanNameShow: false,
            chenckBudget: {},
            chenckOrderBudget: {},
            createId: null,
            planDetail: {},
            planCollectionPrice: 0,
            totalPlanCollectionPrice: 0,
            planCollectionPriceDaiFu1: 0,
            costPrice: 0,
            payCostPrice: 0,
            commissionPrice: 0,
            orderDetailVisible: false,
            customerName: '',
            hasCustomerName: '',
            tableData: [],
            loading: false,
            orderDetailVisible1: false,
            showCostPrice: true,
            linkInquiryVisible: false,
            linkInquiryId: null,
            isUser: null,
            dataType: 0,
            total: 0,
            selectOrderList: [],//勾选的订单
            requestParameters: {
                page: 1,
                size: 10,
                q: {}
            }
        }
    },

    mixins: [Loading],
    methods: {
        invoicePage() {
            this.$refs.invoicePage.beforeOpen()
        },
        changeBudget() {
            this.updateBudgetDialog = true
        },
        linkInquiry() {
            this.linkInquiryVisible = true
        },
        getSelectOrderList(list) {
            console.log(list, 'skdkdkddkkdk=')
            this.selectOrderList = list
        },
        totalPrice(arr) {
            let price = 0
            arr.forEach(n => {
                price += n.price * n.number * n.rate * (this.days(n.startTime, n.endTime) + 1)
            });
            return price.toFixed(2)
        },
        linkInquirySure() {
            new PlanApi('plan').planLinkInquiry({
                planId: this.$store.state.planId,
                inquiryId: this.linkInquiryId,
                isUser: this.isUser
            }).then(res => {
                if (res.status == 200) {
                    this.$message({type: "success", message: "关联成功"})
                    this.linkInquiryId = null;
                    this.isUser = null
                    this.linkInquiryVisible = false
                    getPlanInfo(this.$store.state.planId, '')
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        handleSelect(item) {
            this.linkInquiryId = item.id + ""
            this.isUser = item.isUser
        },
        querySearch(querySearch, cb) {
            new Api('inquiry').grabbingInquiryList({page: 1, size: 10, q: {ids: [querySearch]}}).then(res => {
                if (res.status == 200) {
                    cb(res.data.records);
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        goMyOrder(type) {
            this.orderDetailVisible1 = true
            this.getOrderList(type)
        },
        getOrderList(type) {
            this.loading = true
            var statusList = []
            if (type == 1) {
                statusList.push("1A1A1A")
            } else if (type == 2) {

            } else {

            }
            this.tableData = []
            this.requestParameters.q = {
                planId: this.chenckBudget.planId,
                statusList: statusList,
            }
            new OrderApi('order').platOrderList(this.requestParameters).then(res => {
                this.postOrderListSuccess(res, 0)
            })
            new OrderApi('order').platCustomerOrderList(this.requestParameters).then(res => {
                this.postOrderListSuccess(res, 1)
            })
        },
        loadTable(page, size) {
            this.requestParameters.page = page
            this.requestParameters.size = size
            this.getOrderList()
        },
        postOrderListSuccess(res, type) {
            if (res.status == 200) {
                if (res.data.records.length > 0) {
                    this.dataType = type
                    this.total = res.data.total
                    this.loading = false
                }
                this.tableData.push(...res.data.records)
                res.data.records.forEach((item) => {
                    if (item.truncationResult.opLogResults) {
                        item.truncationResult.opLogResults = sortByCreateTime(item.truncationResult.opLogResults)
                    }
                })
            } else {
                this.$message.error({message: res.statusText})
            }
        },

        goMyCollection(type) {
            this.orderDetailVisible = true
            this.$nextTick(() => {
                this.$refs.myCollectionOrder.chenckBudget = this.chenckBudget
                this.$refs.myCollectionOrder.size = 100
                this.$refs.myCollectionOrder.getList(null, type);
            })
        },
        updateBudgetMainName(type) {
            new PlanApi('plan').updateBudgetMain({
                id: this.chenckBudget.id,
                budgetName: this.chenckBudget.budgetName,
                planName: this.chenckBudget.newPlanName
            }).then(res => {
                if (res.status == 200) {
                    if (this.chenckBudget.newPlanName && this.chenckBudget.newPlanName != '') {
                        this.chenckBudget.planName = this.chenckBudget.newPlanName
                    }
                    if (type == 1) this.updateBudgetMainNameShow = false
                    else this.updatePlanNameShow = false
                } else {
                    this.$message({type: "error", message: res.statusText})
                }
            })
        },
        deleteBudgetMain(item) {
            this.$confirm('您确认删除该方案吗', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                new PlanApi('plan').budgetRemove({id: item.id, planId: item.planId}).then(res => {
                    if (res.status == 200) {
                        this.$message({type: "success", message: "删除成功"})
                        getPlanInfo(this.$store.state.planId, '')
                    } else {
                        this.$message({type: "error", message: res.statusText})
                    }
                })
            }).catch((err) => {
            })
        },
        collection() {
            // this.$refs.collection.init(this.chenckBudget)
            this.$refs.collectionNew.init(this.chenckBudget)
        },
        booking() {
            this.$refs.planDetail.booking(0)
        },
        budgetCheckChangeClick(data) {
            getPlanInfo(this.$store.state.planId, this.budgetList[data].id)
        },
        budgetDetail() {
            this.$refs.budgetDetail.openDialog()
        },
    },
    mounted() {
        this.$Bus.$on("sharePlan", (data) => {
            this.$nextTick(() => {
                this.$refs.planDetail.exportWord()
            })
        });
        this.$Bus.$on("paySuccess", (data) => {
            this.getOrderList()
        });
        getPlanInfo(this.$store.state.planId, this.$store.state.budgetMainId)
        this.$Bus.$on('changePlanInfo', data => {
            this.budgetList = data.budgetMains
            this.createId = data.createId
            this.chenckBudgetIndex = this.budgetList.findIndex(e => e.id == data.budgetMain.id)
            this.chenckBudget = data.budgetMain
            this.$store.commit('setBudgetMainId', data.budgetMain.id)
            this.$store.commit('setPlanId', data.id)
            this.planDetail = data
            if (this.planDetail.inquiries && this.planDetail.inquiries.length > 0) {
                new Api('inquiry').grabbingInquiryList({
                    page: 1,
                    size: 10,
                    q: {ids: this.planDetail.inquiries.map(ee => ee.inquiryId)}
                }).then(res => {
                    this.$Bus.$emit('inquiryCustomerName', res.data.records[0])
                    if (res.data.records[0]) {
                        this.customerName = (res.data.records[0].createCompanyName ? res.data.records[0].createCompanyName : "") + res.data.records[0].createName
                        this.hasCustomerName = 'you'
                    } else {
                        this.customerName = ""
                        this.hasCustomerName = ''
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs.planDetail.init(data, true)
                getBudgetInfo(this.$store.state.budgetMainId)
            })
            //查询收款情况
            new PayApi("pay").planCollectionTotal({
                page: 1,
                size: 100,
                q: {planId: this.$store.state.planId}
            }).then(res => {
                if (res.status == 200) {
                    this.planCollectionPrice = res.data.collctionPrice
                    this.planCollectionPriceDaiFu1 = res.data.totalCollctionPrice//实收
                    this.totalPlanCollectionPrice = res.data.receivableCollctionPrice
                }
            })
        })
        this.$Bus.$on('changeBudgetInfo', (data, data1) => {
            this.costPrice = 0;
            this.payCostPrice = 0;
            data.forEach(ee => {
                var arr = ee.details.filter(eee => eee.stockStatus == 2)
                if (arr.length > 0) {
                    ee.status = 1
                }
                var orderStatusArr = []
                ee.details.forEach(eee => {
                    if (orderStatusArr.findIndex(dd => dd.orderNumber == eee.orderNumber) == -1) {
                        orderStatusArr.push({
                            orderNumber: eee.orderNumber,
                            status: eee.orderStatus
                        })
                    }
                    this.costPrice = this.costPrice + eee.orderPrice
                    if (eee.orderStatus != '待支付') this.payCostPrice = this.payCostPrice + eee.orderPrice
                })
                this.$set(ee, 'orderStatusArr', orderStatusArr)
            })
            this.chenckBudget.planDayList.forEach(e => {
                var budgetDetails = data.filter(item => item.day == e.planDay)
                this.$set(e, 'budgetDetails', budgetDetails)
            })
            this.$refs.planDetail.countPrice('init', data1)
        })
    },
    beforeDestroy() {
        this.$Bus.$off("changePlanInfo");
        this.$Bus.$off("changeBudgetInfo");
        this.$Bus.$off("paySuccess");
        this.$Bus.$off("sharePlan");
    },
    components: {
        Pagination,
        TripDetail,
        budgetDetailDialog,
        MyColletionOrder,
        collection,
        staticTable,
        UpdateBudget,
        CollectionNew,
        InvoicePage
    }
}
</script>

<style lang="scss" scoped>
.tripLeft {
    width: 9.8rem;
    position: absolute;
    top: 1rem;
    left: 0.8rem;
    bottom: 0.02rem;
    overflow: hidden;
    font-size: 0.14rem;

    .top {
        .firstLine {
            display: flex;
            justify-content: center;
            background-color: #f7f7f7;
            align-items: center;
            padding: 0.1rem;

            .planNumber {
                color: #87888A;
                font-size: 0.12rem;
                margin-left: 0.05rem;
            }

            .priceDiv {
                padding: 0rem 0.1rem 0rem 0rem;
                display: flex;
                border-radius: 12px;
                box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.18);
                align-items: center;

                > div:first-child {
                    background-color: #DB4E1A;
                    width: 0.25rem;
                    height: 0.25rem;
                    border-radius: 50%;
                    text-align: center;
                    line-height: 0.25rem;
                    color: white;
                    font-size: 0.14rem;
                    font-weight: bold;
                }
            }
        }

        .secondLine {
            .spanlabel {
                color: rgb(135, 136, 138);
            }

            display: flex;
            background-color: white;

            .blueButton {
                color: rgb(64, 184, 255);
                font-size: 0.12rem;
                background: none;
                border-radius: 4px;
                border: 1px solid rgb(64, 184, 255);
                padding: 0.03rem 0.1rem;
                margin: 0.03rem 0 0.01rem 0.1rem;
            }

            .left {
                width: 50%;
                padding: 0.1rem 0.2rem;

                .budgetDiv {
                    align-items: center;
                    display: flex;

                    .tubiao {
                        width: 0.2rem;
                        height: 0.2rem;
                        background-color: #A894F6;
                        border-radius: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    > span:nth-child(2) {
                        font-size: 0.15rem;
                        margin-left: 0.1rem;
                        font-weight: bold;
                    }

                    > span:nth-child(3) {
                        color: #40b8ff;
                        margin-left: 0.2rem;
                        font-size: 0.12rem;
                    }
                }

                .budgetInfoDiv {
                    padding: 0.1rem 0px;
                    font-size: 0.12rem;
                    display: flex;
                    justify-content: space-between;

                    .planInfo {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        display: inline-block;
                        width: 2rem;
                        color: rgb(64, 184, 255);
                    }

                    .leftInfo {
                        > p:nth-child(2) {
                            margin: 0.1rem 0rem;
                        }

                        > p {
                            > span:nth-child(2) {
                                color: #D4D4D5;
                                padding: 0px 0.1rem;
                            }

                            > span:nth-child(3) {
                                color: #87888A;
                            }
                        }
                    }

                    .rightInfo {
                        display: flex;

                        p:nth-child(2) {
                            margin: 0.1rem 0rem;
                        }
                    }
                }

            }

            .right {
                background-color: #f7f7f7;
                padding: 0.1rem 0.2rem;
                font-size: 0.12rem;
                display: flex;
                width: 50%;
                justify-content: space-between;
                border-bottom-left-radius: 20px;
            }
        }
    }
}
</style>
